// src/pages/MypageInfo.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, TextField, Button, Typography, Container, Alert } from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import api from './api';
import Header from './components/Header';
import { useConfirmBackLogout } from './common/useConfirmBackLogout';
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";


const CorporateMypageInfo = () => {
  const [formData, setFormData] = useState([]);
  const [editing, setEditing] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const [showFormMenu, setShowFormMenu] = useState(false);
  const [sendingReset, setSendingReset] = useState(false);
  const [mypageData, setMypageData] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res1 = await api.get(`/api/corp-mypage/${user.representative_id}`);
        setMypageData(res1.data);
        setFormData(res1.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };


  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    sessionStorage.clear(); // ← これ追加！
    navigate('/');
  };

  const handleSendResetLink = async () => {
    setSendingReset(true);
    try {
      const res = await api.post("/api/request-password-reset", {
        email: formData.email, // ←ここで現在表示中のユーザーのemailを使う
      });
      alert("パスワード再設定リンクをメールで送信しました");
    } catch (err) {
      console.error(err);
      alert("エラーが発生しました。");
    } finally {
      setSendingReset(false);
    }
  };

  const handleSubmit = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    api.put(`/api/corp-mypage/${user?.representative_id}`, formData)
      .then(res => {
        alert("情報を更新しました");
        setEditing(false);
      })
      .catch(err => {
        console.error("更新失敗:", err);
        alert("更新に失敗しました");
      });
  };

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  return (
    <div>
      <Header
        title="メッセナゴヤ 協力会社情報編集"
        companyName={mypageData?.company_name}
      />
       <Container sx={{ display: 'flex' }}>
        <Container sx={{ width: '20%', mt: 4 }}>
            <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box
                className="menu-item"
                onClick={() => {
                const user = JSON.parse(localStorage.getItem('user'));
                const mypage = user?.mypage_url;
                navigate(mypage);
                }}
                >
                TOP
                </Box>
                <Box
                className="menu-item"
                onClick={() => {
                const user = JSON.parse(localStorage.getItem('user'));
                const repId = user?.representative_id;
                navigate(`/corporate-mypage-info/${repId}`);
                }}
                >
                協力会社情報編集
                </Box>
                <Box 
                className="menu-item"
                onClick={() => {
                    navigate('/mail-form/');
                }}
                >
                お問い合わせ
                </Box>
                <Box 
                  className="menu-item"
                  onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user') || '{}');
                    const mypage = user?.mypage_url;

                    handleScrollTo('news', mypage);
                  }}
                >
                  お知らせ
                </Box>
            </Box>
            </Box>
            <BackButton />
        </Container>
        <Container sx={{ width: '80%'}}>
              <Box sx={{ margin: 'auto', mt: 4 }}>
                  <Typography variant="h6" gutterBottom>登録情報の編集</Typography>

                  {['company_name', 'department', 'post', 'user_name', 'zip_code', 'address', 'phone_number', 'email'].map(key => (
                      <TextField
                      key={key}
                      label={key === 'company_name' ? '会社名' :
                              key === 'department' ? '部署名' :
                              key === 'post' ? '役職名' :
                              key === 'user_name' ? '担当者名' :
                              key === 'zip_code' ? '郵便番号' :
                              key === 'address' ? '住所' :
                              key === 'phone_number' ? '電話番号' : 'メールアドレス'}
                      name={key}
                      value={formData[key] || ''}
                      onChange={handleChange}
                      fullWidth
                      margin="normal"
                      />
                  ))}

                  <Button variant="contained" color="primary" onClick={handleSubmit}>
                      保存
                  </Button>
              </Box>
              <Box sx={{ mt: 3 }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleSendResetLink}
                  disabled={sendingReset}
                >
                  パスワードを変更する
                </Button>
              </Box>
        </Container>
       </Container>
       <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
    </div>
  );
};

export default CorporateMypageInfo;
